import {Map} from '../../utils/immutable'
import {BookingState, BookingStateMap} from './types'

export const initialState: BookingStateMap = Map<BookingState>({booking: null, isLoading: false})
